export default __webpack_public_path__ + "static/media/Utric's Seal of Law.6e4b5be9.jpg";